module.exports = __webpack_public_path__ + "assets/img/delivery-sm.2f5a5b56.jpg";